import { HelpOutline } from '@mui/icons-material'
import {
    Box,
    InputAdornment,
    TextField,
    TextFieldProps,
    Tooltip,
} from '@mui/material'
import {
    CandidateFilterCategory,
    SearchIndexField,
} from '__generated__/graphql'
import debounce from 'lodash/debounce'
import { useEffect, useMemo, useState } from 'react'
import { useRosterSearchFilter } from 'recruiter/hooks'
import { getPxAsRem } from 'shared/utils'

export function RosterQuickSearchFilter() {
    const { value, setValue } = useRosterSearchFilter(
        SearchIndexField.RosterQuickSearch
    )

    const searchTermInFilter = value?.value?.string
    const [searchTerm, setSearchTerm] = useState(searchTermInFilter ?? '')

    useEffect(() => {
        if (!searchTermInFilter) setSearchTerm('')
    }, [searchTermInFilter])

    const performDebouncedQuickSearch = useMemo(
        () =>
            debounce((quickSearchString: string) => {
                if (!quickSearchString) {
                    setValue(null)
                    return
                }

                setValue({
                    category: CandidateFilterCategory.Quicksearch,
                    value: { string: quickSearchString },
                })
            }, 500),
        [setValue]
    )

    const handleQuickSearchChange: TextFieldProps['onChange'] = (e) => {
        setSearchTerm(e.target.value)
        performDebouncedQuickSearch(e.target.value)
    }

    return (
        <Box padding={getPxAsRem(16)}>
            <TextField
                fullWidth
                onChange={handleQuickSearchChange}
                label="Quick Search"
                value={searchTerm}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end" sx={{ cursor: 'help' }}>
                            <Tooltip title="Enter a value to filter searches by name or company.">
                                <HelpOutline />
                            </Tooltip>
                        </InputAdornment>
                    ),
                }}
            />
        </Box>
    )
}
